import { useEffect, useMemo, useState } from 'react';
import LoadingSpinner from '../components/LoadingSpinner';
import SearchInput from '../components/SearchInput';
import { endorsementsAPI } from '../services/api';
import { filterBySearch } from '../utils/search';

export default function Endorsements() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');

  const load = () => endorsementsAPI.list().then(({ data }) => setItems(data)).finally(() => setLoading(false));

  useEffect(() => { load(); }, []);

  const filteredItems = useMemo(
    () => filterBySearch(items, search, [
      'endorsement_number',
      'employee_name',
      'endorsement_type',
      'policy_number',
      'status',
    ]),
    [items, search]
  );

  const updateStatus = async (id, status) => {
    await endorsementsAPI.updateStatus(id, status);
    load();
  };

  const downloadPdf = async (id, number) => {
    const { data } = await endorsementsAPI.downloadPdf(id);
    const url = URL.createObjectURL(data);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${number}.pdf`;
    a.click();
    URL.revokeObjectURL(url);
  };

  if (loading) return <LoadingSpinner />;

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold">Endorsements</h1>
        <p className="text-slate-500">M7 — additions/deletions sent to insurer</p>
      </div>

      <SearchInput
        className="max-w-md"
        placeholder="Search by number, employee, policy, status…"
        value={search}
        onChange={setSearch}
      />

      <div className="card overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-slate-500 border-b text-left">
              <th className="pb-2">Number</th><th className="pb-2">Employee</th><th className="pb-2">Type</th>
              <th className="pb-2">Policy</th><th className="pb-2">Status</th><th className="pb-2">Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredItems.map((e) => (
              <tr key={e.id} className="border-b border-slate-100">
                <td className="py-2 font-medium">{e.endorsement_number}</td>
                <td>{e.employee_name}</td>
                <td className="capitalize">{e.endorsement_type}</td>
                <td>{e.policy_number}</td>
                <td><span className="px-2 py-0.5 bg-amber-50 text-amber-700 rounded-full text-xs capitalize">{e.status}</span></td>
                <td className="space-x-2">
                  {e.pdf_path && (
                    <button type="button" className="text-slate-600 text-xs underline" onClick={() => downloadPdf(e.id, e.endorsement_number)}>PDF</button>
                  )}
                  {e.status === 'pending' && <button type="button" className="text-primary-600 text-xs" onClick={() => updateStatus(e.id, 'submitted')}>Submit</button>}
                  {e.status === 'submitted' && <button type="button" className="text-green-600 text-xs" onClick={() => updateStatus(e.id, 'acknowledged')}>Acknowledge</button>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {items.length > 0 && filteredItems.length === 0 && (
          <p className="text-center py-8 text-slate-500">No endorsements match your search.</p>
        )}
      </div>
    </div>
  );
}
